import React from 'react';
import { CheckoutIndex } from "@Src/features/Checkout/CheckoutIndex";
import HomeLayout from "@Src/features/layout/components/HomeLayout/HomeLayout";

export const CheckoutPage = () => {
    return (
        <HomeLayout>
            <CheckoutIndex />
        </HomeLayout>
    );
};
